import { render } from "./Gap.vue?vue&type=template&id=5f7478eb&ts=true"
import script from "./Gap.vue?vue&type=script&lang=ts"
export * from "./Gap.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__